import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "originalButton"]
  static values = {
    threshold: { type: Number, default: 200 }
  }

  connect() {
    // Guard: show/hide 対象の sticky button (button ターゲット) が無ければ動作不要。
    // home (#1555 #5) のように、未ログイン時のみ両ターゲットが描画されるケースで
    // signed-in path に controller が attach されてもエラーにならないようにする。
    // originalButton は optional のまま (無しでも scroll-threshold-only モードで動く)。
    if (!this.hasButtonTarget) return

    this.isVisible = false
    this.originalButtonVisible = false
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })

    // Intersection Observer for original button (originalButton は optional)
    if (this.hasOriginalButtonTarget) {
      this.setupIntersectionObserver()
    }

    // Initial check
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.originalButtonVisible = entry.isIntersecting
          this.updateVisibility()
        })
      },
      { threshold: 0.1 }
    )
    this.observer.observe(this.originalButtonTarget)
  }

  handleScroll() {
    this.updateVisibility()
  }

  updateVisibility() {
    const scrollY = window.scrollY
    const scrolledEnough = scrollY > this.thresholdValue
    const shouldShow = scrolledEnough && !this.originalButtonVisible

    if (shouldShow && !this.isVisible) {
      this.show()
    } else if (!shouldShow && this.isVisible) {
      this.hide()
    }
  }

  show() {
    this.isVisible = true
    this.buttonTarget.classList.remove("translate-y-full", "opacity-0")
    this.buttonTarget.classList.add("translate-y-0", "opacity-100")
  }

  hide() {
    this.isVisible = false
    this.buttonTarget.classList.remove("translate-y-0", "opacity-100")
    this.buttonTarget.classList.add("translate-y-full", "opacity-0")
  }
}
